import React from "react";
import PropTypes from "prop-types";
import { findMatch } from "LIB/arrays";
import { Field, Fields } from "redux-form";
import { addressFormatDropDown } from "LIB/formatters/address";
import {
  DO_NOT_SHIP,
  DO_NOT_SHIP_REASONS
} from "MODULES/PurchaseOrders/constants";
import { Select, FormInput } from "MODULES/shared/components/Forms";
import AddressFields from "MODULES/companies/components/AddressFields";
import { toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import ShippingRadioGroupField from "MODULES/Locations/components/ShippingRadioGroupField";
import {
  COMPANY,
  DROPSHIP
} from "MODULES/shared/components/ShippingSection/shippingTypes";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import {
  FOB,
  SHIP_TO_LOCATION_ID,
  SHIPPING_ADDRESS,
  SHIPPING_TYPE
} from "APP_ROOT/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { SHIP_DATE } from "MODULES/Lots/constants";
import { Col } from "react-bootstrap";
import DoNotShipReasonFields from "MODULES/Orders/shared/ShippingFields/DoNotShipReasonFields";
import { REPAIR_STATION } from "MODULES/companies/constants";
import CompanyFields from "./CompanyFields";

export const SHIPPING_TYPES = {
  company: {
    label: "Company"
  },
  dropship: {
    label: "Other"
  },
  do_not_ship: {
    label: "Do Not Ship"
  },
  repair_station: {
    label: "Repair Station Address"
  }
};

function ToggledShipToFields(props) {
  const {
    shipToCompany,
    country,
    city,
    disabled,
    province,
    formName,
    onChangeShippingPreference,
    repairStationOptions = [],
    setFOB,
    shippingFields,
    shippingAddressField = SHIPPING_ADDRESS,
    required = true,
    enableReturnToType = true
  } = props;
  const shippingTypeField = props[findMatch(props.shippingFields, "type")];
  const shippingType = shippingTypeField.input.value;

  const addressOptions = repairStationOptions.map(a => ({
    text: addressFormatDropDown(a),
    value: a.id
  }));

  return (
    <div>
      {shippingFields.includes(FOB) === true && (
        <FormRow>
          <Col md={7}>
            <Field
              name={FOB}
              component={FormInput}
              label={FOB.toUpperCase()}
              required
            />
          </Col>
          <Col md={5}>
            <Field
              name={SHIP_DATE}
              component={FormInput}
              type="date"
              label={properCase(SHIP_DATE)}
              disabled={disabled}
            />
          </Col>
        </FormRow>
      )}
      {shippingType === COMPANY && (
        <Fields
          component={CompanyFields}
          formName={formName}
          names={shippingFields}
          onChangeShippingPreference={onChangeShippingPreference}
          selectedCompany={shipToCompany}
          setFOB={setFOB}
          required
          disabled={disabled}
        />
      )}
      {shippingType === DROPSHIP && (
        <AddressFields
          formName={formName}
          path={shippingAddressField}
          country={country}
          city={city}
          setFOB={setFOB}
          province={province}
          addCompanyName
          required={required}
          disabled={disabled}
        />
      )}
      {shippingType === REPAIR_STATION && (
        <FormRow>
          <Col md={6}>
            <Field
              name="repair_station_physical_address_id"
              component={Select}
              options={addressOptions}
              label="Repair Station Address"
              required
              prompt={false}
            />
          </Col>
        </FormRow>
      )}
      {shippingType === DO_NOT_SHIP &&
        enableReturnToType &&
        formName !== "rmaReturnToDetails" && (
          <Fields
            names={[shippingTypeField.input.name, ...DO_NOT_SHIP_REASONS]}
            component={DoNotShipReasonFields}
            required={required}
          />
        )}
    </div>
  );
}

ToggledShipToFields.propTypes = {
  country: PropTypes.string,
  city: PropTypes.string,
  province: PropTypes.string,
  formName: PropTypes.string,
  setFOB: PropTypes.func,
  repairStationOptions: PropTypes.arrayOf(PropTypes.shape({})),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  shippingAddressField: PropTypes.string,
  shippingFields: PropTypes.arrayOf(PropTypes.string),
  shipToCompany: PropTypes.instanceOf(Object)
};

function ShipToFields(props) {
  const shippingType = findMatch(props.shippingFields, "type");
  const shippingTypeLabel =
    shippingType === SHIPPING_TYPE ? "Ship To" : properCase(shippingType);

  const shippingTypes = props.shippingTypes.reduce((types, t) => {
    types[t] = SHIPPING_TYPES[t];
    return types;
  }, {});

  const required =
    props.rmaRequestForm || shippingType === "return_to_type"
      ? false
      : props.required;
  return (
    <div>
      <Field
        name={shippingType}
        label={shippingTypeLabel}
        component={ShippingRadioGroupField}
        options={toOptions(shippingTypes)}
        required={required}
        disabled={props.disabled}
        setFieldValue={props.setFieldValue}
        getFieldValue={props.getFieldValue}
        hasLocations={props.hasLocations}
        locationFieldName={props.locationFieldName}
      />
      <Fields
        names={[shippingType]}
        component={ToggledShipToFields}
        {...props}
      />
    </div>
  );
}

export default withFieldAccessors(ShipToFields);

ShipToFields.defaultProps = {
  hasLocations: true,
  shippingTypes: [COMPANY, DROPSHIP, DO_NOT_SHIP],
  locationFieldName: SHIP_TO_LOCATION_ID
};

ShipToFields.propTypes = {
  hasLocations: PropTypes.bool,
  locationFieldName: PropTypes.string,
  required: PropTypes.bool,
  shippingFields: PropTypes.arrayOf(PropTypes.string),
  shippingTypes: PropTypes.arrayOf(PropTypes.string)
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/ShippingFields/ShipToFields.jsx